import $ from 'jquery';
import simpleUtil from 'simple-util';

import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import resourceSubject from 'next/javascripts/reactivity/resource-subject';

Component('tr-project-kanban', {
  mixins: [eventListenerMixin],

  properties: {
    groupBy: String,
    labelHidden: {
      type: Boolean,
      value: false,
    },
    sortable: Boolean,
    forwardTodoUrl: String,
  },

  connected() {
    window.scrollTo(0, 0);
    document.body.classList.add('body-kanban');
    $(this).on('click', '.todo-label', this.handleLabelClick.bind(this));
  },

  ready() {
    this.navigateToForwardTodo();

    const labelHidden = simpleUtil.storage.get(`${window.location.pathname}label-hidden`);
    if (labelHidden) this.labelHidden = labelHidden === 'true';

    this.initSubscription();
    if (this.sortable) this.initSortTodolist();
  },

  initSubscription() {
    this.subscription = resourceSubject('todo').subscribe({
      next: this.syncTodoStatus.bind(this),
    });
  },

  navigateToForwardTodo() {
    if (!this.forwardTodoUrl) return;

    const dialogPage = this.querySelector('tr-dialog-page');
    if (dialogPage) dialogPage.requestPage(this.forwardTodoUrl);
  },

  handleLabelClick() {
    this.labelHidden = !this.labelHidden;
    simpleUtil.storage.set(`${window.location.pathname}label-hidden`, this.labelHidden);
  },

  handleUpdateImageMenu(todoKanban, todoId) {
    if (todoKanban.length > 0) {
      const kanbanMenu = todoKanban[0].querySelector('.kanban-todo-menu');
      if (kanbanMenu) {
        $.ajax({
          url: `/todos/${todoId}/kanban_todo_menu`,
          method: 'get',
          data: {
            hide_menu: true,
          },
          dataType: 'script',
        });
      }
    }
  },

  syncTodoStatus(event, todo) {
    if (!document.body.classList.contains('body-kanban')) return;

    const $todo = $(`tr-kanban-todo#todo_${todo.id}`);

    if (event === 'update') {
      this.handleUpdateImageMenu($todo, todo.id);
      if (!todo.html) return;
      const $newTodo = $(todo.html);
      $todo.replaceWith($newTodo);
      this.moveTodoToContainer($newTodo);
    } else if (event === 'destroy') {
      $todo.remove();
      const page = document.querySelector('.tr-page');
      if (page && page.opened) page.close();
    } else if (event === 'move') {
      if (!$todo.length) return;

      const $todolist = $(`.todolist[data-guid="${todo.todolistGuid}"]`);
      if ($todolist.length && !todo.isSubTodo) {
        if ($todo.is('[completed="true"]')) {
          $todolist.find('.todos-completed').prepend($todo);
        } else {
          $todolist.find('.todos-uncompleted').prepend($todo);
        }
      } else {
        $todo.remove();
      }
    }

    this.refreshListCount();
  },

  reload() {
    window.tower.stack.load(window.location.href, {
      root: true,
      replace: true,
      nocache: true,
      fluid: true,
    });
  },

  initSortTodolist() {
    const $todolists = $(this).find('.todolists');

    $todolists.sortable({
      axis: 'x',
      handle: 'tr-kanban-todolist-title',
      distance: 5,
      scrollSensitivity: 100,
      items: 'tr-kanban-todolist',
      placeholder: 'todolist-placeholder',
      update(e, ui) {
        const guids = Array.prototype.map.call(
          e.target.querySelectorAll('tr-kanban-todolist-title'),
          todolist => todolist.guid,
        );
        $.ajax({
          url: ui.item.find('tr-kanban-todolist-title').data('sort-url'),
          type: 'post',
          dataType: 'json',
          data: {
            guids: guids.join(','),
          },
        });
      },
    });
  },

  refreshListCount() {
    [...document.querySelectorAll('tr-kanban-todolist')].forEach((ele) => {
      ele.updateTodoCount();
    });
  },

  disconnected() {
    this.stopListening();
    this.subscription.unsubscribe();
    document.body.classList.remove('body-kanban');
  },

  moveTodoToContainer($newTodo) {
    if ($newTodo.closest('.todos-uncompleted').length > 0 && $newTodo.prop('completed')) {
      const $completed = $newTodo.closest('.todos-container').find('.todos-completed');
      $completed.prepend($newTodo);
    } else if ($newTodo.closest('.todos-completed').length > 0 && !$newTodo.prop('completed')) {
      const $uncompleted = $newTodo.closest('.todos-container').find('.todos-uncompleted');
      $uncompleted.append($newTodo);
    }
  },
});
